var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5526_571)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5942 39.9939C29.3652 39.9939 29.1392 39.9729 28.9202 39.9329C27.4532 39.6659 25.9732 38.4699 25.9732 36.4009V30.0069H19.5942C17.5232 30.0079 16.3272 28.5269 16.0602 27.0589C15.7932 25.5919 16.3912 23.7859 18.3282 23.0559L34.7222 16.2629C36.1952 15.7079 37.7692 16.0469 38.8582 17.1369C39.9492 18.2269 40.2882 19.7999 39.7442 21.2419L32.9142 37.6989C32.3032 39.3199 30.9022 39.9939 29.5942 39.9939Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5526_571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f60c82e1e62fb27b70e118a53f7c2f5f.svg";
export { ForwardRef as ReactComponent };